// CONSTANTS are all caps.
const NS = 'AssistanceServiceBlock';
const CLS = 'assistanceServiceBlock';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class AssistanceServiceBlock {
	constructor($el) {
		// $el is the blk node return by the CalloutStaticBlock function
		this.$el = $el;
	}

	init() {
		this.setAssistanceServiceBlock();
	}

	setAssistanceServiceBlock() {
		let maxHeight = Math.max.apply(null, $(`.${CLS}-cardBody`).map(function() {
			return $(this).innerHeight();
		}).get());

		$(`.${CLS}-cardBody`).height(maxHeight);
	}

	// Add more functions like on above here
}
